import {
  OFFCANVAS_DEFAULT_QUERY_PARAMETER,
  useOffcanvasOpenState,
} from './useOffcanvasOpenState';

export const useNavigationCategory = () => {
  const {open, parameter} = useOffcanvasOpenState();
  const currentCategoryId = parameter || undefined;

  const setCurrentCategoryId = (categoryId?: number) => {
    open({
      replaceHistory: true,
      parameter: categoryId
        ? `${categoryId}`
        : OFFCANVAS_DEFAULT_QUERY_PARAMETER,
    });
  };

  return {
    currentCategoryId,
    setCurrentCategoryId,
  };
};
